module.exports = __webpack_public_path__ + "img/pcpomotion.4c764334.jpg";